import { api } from '@kolab/dms-base/api'
import type {
  CreateDistributorRequest,
  Distributor,
  PaginatedResponse,
  PageableQuery,
  SetDistributorStatusRequest,
  UpdateDistributorRequest,
} from './types'

const BASE = '/v1/distributors'

export async function listDistributors(params?: PageableQuery) {
  return api.get<PaginatedResponse<Distributor>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getDistributor(id: string) {
  return api.get<Distributor>(`${BASE}/${id}`).then((r) => r.data)
}

export async function createDistributor(payload: CreateDistributorRequest) {
  return api.post<Distributor>(BASE, payload).then((r) => r.data)
}

export async function updateDistributor(id: string, payload: UpdateDistributorRequest) {
  return api.put<Distributor>(`${BASE}/${id}`, payload).then((r) => r.data)
}

export async function setDistributorStatus(id: string, payload: SetDistributorStatusRequest) {
  return api.put<Distributor>(`${BASE}/${id}/status`, payload).then((r) => r.data)
}

export async function softDeleteDistributor(id: string) {
  return api.delete<Distributor>(`${BASE}/${id}`).then((r) => r.data)
}
